// pricing.js – Preisberechnung (an einer Stelle für Preisfenster und Bestellung)

// Packs: Platz für so viele Personen, Preis pro Exemplar
export const PACKS = [
  { size: 12, price: 36.95 },
  { size: 24, price: 44.95 },
  { size: 36, price: 52.95 },
];
export const LIEFERKOSTEN = 10;     // pro Bestellung (wird später genauer definiert)
export const RETOUCH_PRICE = 5;     // pro Bild, das von Hand bearbeitet wird (einmalig)

// Günstigste Kombination von Packs, die alle Personen fasst (auch über 36 Personen)
export function cheapestPacks(persons) {
  let best = { price: Infinity, packs: [] };
  const sorted = [...PACKS].sort((a, b) => b.size - a.size);
  (function search(remaining, packs, cost, start) {
    if (cost >= best.price - 1e-9) return;
    if (remaining <= 0) { best = { price: cost, packs: [...packs] }; return; }
    for (let i = start; i < sorted.length; i++) {   // nur Kombinationen, keine Wiederholungen in anderer Reihenfolge
      packs.push(sorted[i]);
      search(remaining - sorted[i].size, packs, cost + sorted[i].price, i);
      packs.pop();
    }
  })(Math.max(1, persons), [], 0, 0);
  best.price = Math.round(best.price * 100) / 100;
  return best;
}

// „36er + 12er“ bzw. „2× 24er“
export function packSummary(packs) {
  const counts = {};
  packs.forEach(p => { counts[p.size] = (counts[p.size] || 0) + 1; });
  return Object.keys(counts).sort((a, b) => b - a)
    .map(size => (counts[size] > 1 ? `${counts[size]}× ` : '') + `${size}er-Pack`).join(' + ');
}

// „2× 36er-Pack“ (1 Exemplar) bzw. „3 Exemplare à 2× 36er-Pack (105.90 CHF)“
export function packLine(copies, price) {
  const packs = packSummary(price.packs);
  return copies === 1 ? packs : `${copies} Exemplare à ${packs} (${fmt(price.packPrice)})`;
}

export function calcPrice({ persons, copies = 1, retouchCount = 0 }) {
  const { price: packPrice, packs } = cheapestPacks(persons);
  const druck = round(packPrice * copies);
  const retouch = round(retouchCount * RETOUCH_PRICE);
  const liefer = LIEFERKOSTEN;
  return { packPrice, packs, druck, retouch, liefer, total: round(druck + retouch + liefer) };
}

function round(v) { return Math.round(v * 100) / 100; }
export function fmt(v) { return v.toFixed(2) + ' CHF'; }
